import { render, staticRenderFns } from "./BookingRoomAddChargeTable.vue?vue&type=template&id=62e26ca8"
import script from "./BookingRoomAddChargeTable.vue?vue&type=script&lang=js"
export * from "./BookingRoomAddChargeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports